import { Question, Reply, Value } from "containers/Survey/types"

import styles from "./Question.module.scss"

/*
 * Every line of a "questions_line" step: a picture, a label and its yes/no replies.
 * `answers` holds the current value of each line, by line id.
 * `hint` is shown right under the lines.
 */
export const UiQuestionsLine = (props: {
  question: Question
  answers: Record<string, Value>
  onSelect: (lineId: string, reply: Reply) => void
  hint?: string
}): JSX.Element => {
  return (
    <div className={styles.QuestionsLine}>
      {(props.question.questions ?? []).map((line) => (
        <div key={line.id} className={styles.QuestionLineItem}>
          {line.imgUrl && (
            <img src={line.imgUrl} alt="" className={styles.QuestionLineItemImage} />
          )}
          <div className={styles.QuestionLineItemTitle}>
            <span>{line.title}</span>
            {line.subtitle && (
              <span className={styles.QuestionLineItemSubtitle}>
                {line.subtitle}
              </span>
            )}
          </div>
          <div className={styles.QuestionLineItemReplies}>
            {line.replies.map((reply) => (
              <button
                key={String(reply.value)}
                type="button"
                onClick={() => props.onSelect(line.id, reply)}
                className={
                  props.answers[line.id] === reply.value
                    ? styles.Selected
                    : undefined
                }
              >
                {reply.title}
              </button>
            ))}
          </div>
        </div>
      ))}
      {props.hint && (
        <div className={styles.QuestionsLineHint}>{props.hint}</div>
      )}
    </div>
  )
}
